/**
 * Authentication utilities
 */

/**
 * Handles user sign-out with support for both SSO and non-SSO authentication
 * @param {Object} auth - The auth object from useAuth() hook
 * @param {Object} user - The user object containing authentication details
 * @returns {Promise<void>}
 */
export const handleSignOut = async (auth, user) => {
    if (!auth) {
        console.error("Auth object is required for sign-out");
        return;
    }

    try {
        // For SSO-enabled users
        if (!user || (user?.ssoEnabled && user?.sloEnabled)) {
            document.cookie = "SLO_REDIRECT=" + auth.settings.post_logout_redirect_uri + "; " +
                "Domain=qualifacts.org; Path=/; Secure; SameSite=None;";

            await auth.revokeTokens();
            await auth.removeUser();
            
            // Redirect to SLO endpoint for SSO users
            if (auth.user?.id_token) {
                window.location.href = auth.settings.authority +
                    "/saml20/startslo?id_token_hint=" + auth.user.id_token;
            } else {
                window.location.href = auth.settings.authority + "/saml20/startslo";
            }
            
        } else {
            // For non-SSO users
            await auth.signoutRedirect();
        }
    } catch (error) {
        console.error("Error during sign-out:", error);
    }
};

/**
 * Default export for the auth utilities
 */
const authUtils = {
    handleSignOut
};

export default authUtils;
